import {
  useCreateSelectedCandidateBatchStatusesMutation,
  useUpdateSelectedCandidateBatchStatusesMutation
} from 'generated-graphql/hooks/apollo-hooks';
import {
  CreateSelectedCandidateBatchStatusesInput,
  UpdateSelectedCandidateBatchStatusesInput
} from 'generated-graphql/types';

export const useUpsertSelectedCandidateBatchStatuses = () => {
  const [createSelectedCandidateBatchStatuses] =
    useCreateSelectedCandidateBatchStatusesMutation();
  const [updateSelectedCandidateBatchStatuses] =
    useUpdateSelectedCandidateBatchStatusesMutation();

  const upsertSelectedCandidateBatchStatuses = (
    input: Omit<UpdateSelectedCandidateBatchStatusesInput, 'id'> & {
      id?: string;
    }
  ) => {
    if (input.id) {
      return updateSelectedCandidateBatchStatuses({
        variables: { input: input as UpdateSelectedCandidateBatchStatusesInput }
      });
    }
    return createSelectedCandidateBatchStatuses({
      variables: { input: input as CreateSelectedCandidateBatchStatusesInput }
    });
  };

  return {
    upsertSelectedCandidateBatchStatuses
  };
};
